/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var DefaultImageBusiness;

(function (DefaultImageBusiness) {
  DefaultImageBusiness["BROKER_PRODUCTION_BANNER_BUSINESS"] = "broker_production_banner_business";
  DefaultImageBusiness["BROKER_PRODUCTION_BANNER_GIT"] = "broker_production_banner_git";
  DefaultImageBusiness["BROKER_PRODUCTION_BANNER_BAK_2025_11_26"] = "broker_production_banner_bak_2025_11_26";
})(DefaultImageBusiness || (DefaultImageBusiness = {}));